import { App } from '@capacitor/app';

/** Lo que se espera al sistema. Todas las llamadas a la API esperan a este número (`cabecerasCliente`). */
export const ESPERA_BUILD_MS = 1000;

/**
 * El número de compilación del binario instalado: `CFBundleVersion` en iPhone y `versionCode` en
 * Android (hoy 11). Es el que decide si hay que actualizar desde la tienda; la versión del
 * `package.json` es la de la web que va dentro y, con OTA, dejaría de coincidir.
 *
 * Si no se puede leer —o el sistema no responde en {@link ESPERA_BUILD_MS} ms— devuelve `null`, sin
 * lanzar: quien lo use decide qué hacer sin él. Nunca se queda colgado.
 */
export const buildNativo = async (): Promise<number | null> => {
	let reloj: ReturnType<typeof setTimeout> | undefined;
	const sinRespuesta = new Promise<null>((resolver) => {
		reloj = setTimeout(() => resolver(null), ESPERA_BUILD_MS);
	});

	try {
		const info = await Promise.race([App.getInfo(), sinRespuesta]);
		if (info === null) {
			return null;
		}
		const numero = Number.parseInt(info.build, 10);
		return Number.isNaN(numero) ? null : numero;
	} catch {
		return null;
	} finally {
		clearTimeout(reloj);
	}
};

let guardado: number | null = null;

/**
 * El build, para todo lo demás (cabeceras y versión mínima): el MISMO número para los dos y leído una
 * sola vez, porque el binario no cambia con la app abierta. Si no se pudo leer (`null`), no se guarda:
 * la siguiente vez se reintenta, para no quedarse sin él toda la sesión por un arranque lento.
 */
export const buildDelBinario = async (): Promise<number | null> => {
	if (guardado === null) {
		guardado = await buildNativo();
	}
	return guardado;
};

/** Solo para los tests: empezar sin build guardado. */
export const olvidarBuildDelBinario = (): void => {
	guardado = null;
};
